<template>
  <div class="address-slider">
    <h2>{{$t('selectAddressFordelivery')}}</h2>
    <ul>
      <li class="custom-checkbox" v-for="(address,index) in userAddressData" :key="index">
        <div  @click="selectAddress(address.addressId,index, address.zipcode)">
        <!-- <input type="radio" name="radio-1" :checked="address.addressId" /> -->
        <span class="check-mark" :class="{'active' :index==activeIndex }"></span>
        <span class="name">{{address.personName}}</span>
        <span class="number">{{address.contactNumber}}</span>
        <span class="address">{{address.address}}</span>
        <span class="address">{{address.city}} {{address.state}}-{{address.zipcode}}</span>
        <span class="delete" @click="goToAddAddress(address.addressId)">
          <span >Edit</span>
        </span>
        </div>
      </li>    
    </ul>
    <router-link tag="span" class="btn" :to="{ path: '/address-detail'}">{{$t('addNewAddress')}}</router-link>
  </div>
</template>
<script>
import ImageSpinner from "../Common/ImageSpinner";
import apicaller from "../../utils/apicaller";
export default {
  name: "AddressDetail",
  data(){
    return{
      activeIndex:0,
      isCodEnable: false,
      isNearPayEnable: false
    }
  },
  props: {
    userAddressData: {
      type: Array
    }
  },
  methods: {
    selectAddress(id,index, zipcode){
      this.activeIndex=index;
      this.$emit('selectAddressId' , id)    
      if(zipcode){
        this.$store
          .dispatch({
            type: "getPincodeDetails",
            payload: zipcode
          })
          .then(data => {
            this.isCodEnable = data.data.codEnabled
            this.isNearPayEnable = data.data.nearPayEnabled
          })
          .catch(err => {
            this.loading = false;
          });
      }      
      this.$emit('nearPayEnable' , this.isNearPayEnable)
      this.$emit('codEnable' , this.isCodEnable)
    },
    getPincodeDetails() {
      if (this.getAddress.zipcode.length > 5) {
        this.loading = true;
        const userPincode = this.getAddress.zipcode;
        this.$store
          .dispatch({
            type: "getPincodeDetails",
            payload: userPincode
          })
          .then(data => {
            console.log(data.data)
          })
          .catch(err => {
            this.loading = false;
          });
      }
    },
    goToAddAddress(id) {
      this.$router.push("/address-detail?addressId=" + id);
    }
  },
};
</script>